import React from 'react';

import { uuid } from 'uuidv4';
import {
  SearchComponent,
  ISearchComponent,
} from '../../components/SearchComponent';
import createModule from '../../components/SearchComponent/modules/Create';
import updateModule from '../../components/SearchComponent/modules/Update';
import deleteModule from '../../components/SearchComponent/modules/Delete';
import { Container, Header, Body } from './styles';
import api from '../../services/api';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}

const Lesson: React.FC = () => {
  const endpoint = '/lessons';

  const formSchema = {
    title: {
      model: 'input',
      name: 'title',
      label: 'Título',
      defaultValue: '',
    },
    room_reference: {
      alias: 'room_reference',
      model: 'selectApi',
      name: 'room_reference',
      label: 'Sala',
      defaultValue: 1,
      endpoint,
    },
    image: {
      model: 'input',
      name: 'image',
      label: 'Foto',
      defaultValue: '',
    },
    category_id: {
      alias: 'category_id',
      model: 'selectApi',
      name: 'category_id',
      label: 'Categoria',
      defaultValue: 1,
      endpoint,
    },
    dificulty_id: {
      alias: 'dificulty_id',
      model: 'selectApi',
      name: 'dificulty_id',
      label: 'Nível',
      defaultValue: 1,
      endpoint,
    },
    video_type_id: {
      alias: 'video_type_id',
      model: 'selectApi',
      name: 'video_type_id',
      label: 'Tipo de Vídeo',
      defaultValue: 1,
      endpoint,
    },
    video_id: {
      model: 'input',
      name: 'video_id',
      label: 'Código do Vídeo',
      defaultValue: '',
    },
    visible_id: {
      alias: 'visible_id',
      model: 'selectApi',
      name: 'visible_id',
      label: 'Visível no Menu?',
      defaultValue: 2,
      endpoint,
    },
    release_date: {
      model: 'datePicker',
      name: 'release_date',
      label: 'Data de Lançamento',
      defaultValue: '',
    },
    teachers: {
      model: 'JsonInput',
      bodyRender: (data: Record<string, any>) => (
        <nav>
          <strong>
            (
{data.id})
{data.name}
          </strong>
          <br />
          {data.release_date_formatted || data.release_date}
        </nav>
      ),
      searchRender: (data: Record<string, any>) => (
        <>
          <strong>
            (
{data.id})
{' '}
{data.name}
          </strong>
          <br />
          {data.release_date_formatted || data.release_date}
        </>
      ),
      storageType: 'json',
      endpoint: `${endpoint}/feedSelect/teachers`,
      name: 'teachers',
      label: 'Professores',
    },
  };

  const formValidation: Record<string, ValidationSchema> = {
    title: {
      name: 'title',
      type: 'string',
      label: 'Título',
      rules: [{ type: 'required' }],
    },
    video_id: {
      name: 'video_id',
      type: 'string',
      label: 'Código do Vìdeo',
      rules: [{ type: 'required' }],
    },
  };

  const key2 = uuid();

  const schema2: Record<string, any> = {
    id: { ref: 'id', column: 'id', label: 'ID' },
    title: { ref: 'title', column: 'title', label: 'Título' },
    image: { ref: 'image', column: 'image', label: 'Foto' },
    video_type_id: {
      ref: 'video_type_id',
      column: 'video_type',
      includeColumn: 'title',
      label: 'Tipo de Vídeo',
    },
    room_reference: {
      ref: 'room_reference',
      column: 'room_rederence_response',
      includeColumn: 'title',
      label: 'Sala',
    },
    category_id: {
      ref: 'category_id',
      column: 'category',
      includeColumn: 'title',
      label: 'Categoria',
    },
    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const config2: ISearchComponent = {
    idKey: key2,
    title: 'aulas',
    endpoint: '/lessons',
    schema: schema2,
    autoStart: true,
    headModules: [
      () =>
        createModule({
          title: 'Aulas',
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        updateModule({
          lineData,
          title: 'Aulas',
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        deleteModule({
          lineData,
          title: 'Aula',
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config2} />
    </Container>
  );
};

export default Lesson;
